












































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
    deleteDenounce,
    getDenounce,
    getDenounces,
    patchDenounce,
    getPrograms,
    getNumberDenouncesPending,
} from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import User from '../models/User';
import get from 'lodash/get';
import { roles, formatRoles } from '@/data/roles';
import { Role } from '@/models/Role';

import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import AuthModule from '@/store/AuthModule';

import Denounce from '../models/Denounce';
import Program from '../models/Program';
import {
    fetchPrescriberDenounce, fetchProgramDenounce, fetchOperatorsDenounce ,
    fetchProspectsAdminDenounce,
} from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import Datatable from '@/components/Datatable.vue';
import { denouceStatus } from '@/data/denouceStatus';
import { formatDenounceProspectStatus } from '@/data/denounceProspectStatus';
import { projects } from '@/data/denounceProjects';
import SidebarModule from '../store/SidebarModule';
import formatCustomer from '@/utils/formatCustomer';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import Lot from "@/models/Lot";
import Boolean from "@/components/Boolean.vue";
import { getTaxSystemValue } from '@/data/taxSystems';

@Component({
    components: {
        Datatable,
        FilterComponent,
        Boolean,
    },
    filters: {
        formatCustomer,
        formatDenounceProspectStatus,
        getTaxSystemValue,
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        formatDateHour: (value: string) => {
            return value ? moment(value).format('LT') : null;
        },
        fluxFormat: (value: boolean) => {
          if (value){
            return 'OUI';
          }else{
            return 'NON';
          }
        }
    },
})
export default class Denounces extends Vue {
    delete_comments: string = '';
    showDeleteCommentsPopUp: boolean = false;
    denounce: Denounce | null = null;
    denouncePop: Denounce | null = null;
    moment = moment; // Expose moment to template

    // NOUVELLES VARIABLES POUR LE RÉCAP DOCUMENTS
    showDocumentsRecapPopup: boolean = false;
    selectedDenounce: Denounce | null = null;
    documentsRecapStep: number = 1;
    validationBackofficeComment: string = '';
    validationTauxCommission: string = '';

    // Popup de détail/édition des commentaires (Prescriber / BackOffice)
    commentPopupVisible: boolean = false;
    commentPopupTitle: string = '';
    commentPopupField: 'message_text' | 'backoffice_comment' = 'message_text';
    commentPopupRecord: Denounce | null = null;
    commentPopupText: string = '';
    commentPopupDraft: string = '';
    commentPopupEditing: boolean = false;
    commentPopupSaving: boolean = false;

    // Popup de détail/édition du taux de commission
    commissionPopupVisible: boolean = false;
    commissionPopupRecord: Denounce | null = null;
    commissionPopupValue: string = '';
    commissionPopupDraft: string = '';
    commissionPopupEditing: boolean = false;
    commissionPopupSaving: boolean = false;

    yearModel: string = 'all';
    operatorModel: string | undefined | null = null;

    projects = projects;

    // Types de documents attendus (basé sur ProgramDocument::TYPES)
    documentTypesList = [
        { key: 'images', label: 'Images du programme', essential: false },
        { key: 'documents_annual_charge', label: 'Décompte charge et 3 AG', essential: true },
        { key: 'documents_notice', label: 'Notice descriptive', essential: true },
        { key: 'documents_parking_plan', label: 'Plan des parkings', essential: false },
        { key: 'documents_floor_plan', label: 'Plan des étages', essential: true },
        { key: 'documents_global_plan', label: 'Plan de masse', essential: false },
        { key: 'documents_booking_contract', label: 'Doc Contrat Résa', essential: true },
        { key: 'documents_works_contract', label: 'Marché de travaux', essential: false },
        { key: 'documents_commercial_brochure', label: 'Plaquette commerciale', essential: true },
        { key: 'documents_management_brochure', label: 'Relevé de gérance', essential: false },
        { key: 'documents_rental_agreement', label: 'Bail/relève gérance', essential: false },
        { key: 'documents_general_assembly', label: 'Assemblée générale', essential: false },
        { key: 'documents_autres', label: 'Autres', essential: false },
    ];

    popupLots = false;
    lots: Lot | null = null;
    prescriber: string = '';
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: 'status',
        orderWay: 'ASC',
        filters: {
            prescriber: undefined,
            program: undefined,
            status: undefined,
            statusPrescriber: undefined,
            customer:undefined,
            operator: undefined,  
            year: null
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
          title: 'Date Dénonce',
          dataIndex: 'created_at',
          scopedSlots: {
            customRender: 'date',
          },
          sorter: true,
        },
        {
          title: 'Rendez-vous',
          dataIndex: 'appointment_date',
          scopedSlots: {
            customRender: 'appointment_date',
          },
          sorter: true,
        },
        {
          title: 'Statut',
          dataIndex: 'status',
          scopedSlots: {
            customRender: 'status',
          },
          sorter: true,
          defaultSortOrder: 'ascend',
        },
        {
          title: 'Opérateur',
          dataIndex: 'operator',
          scopedSlots: {
            customRender: 'operator',
          }
        },
        {
            title: 'Prescripteur',
            dataIndex: 'customer.prescriber',
            sorter: true,
            scopedSlots: {
                customRender: 'prescriber',
            },
        },
        {
            title: 'Statut prescripteur',
            dataIndex: 'customer.prescriber.family',
            sorter: true,
        },
        {
          title: 'Prospect acquéreur',
          dataIndex: 'customer',
          sorter: true,
          scopedSlots: {
            customRender: 'customer',
          },
        },
        {
            title: 'Tx commission NOUS',
            dataIndex: 'taux_commission',
            sorter: true,
            scopedSlots: {
                customRender: 'taux_commission',
            }
        },
        {
            title: 'Projet',
            dataIndex: 'project',
            sorter: true,
            scopedSlots: {
                customRender: 'project',
            }
        },
        {
            title: 'Commentaire BackOffice',
            dataIndex: 'backoffice_comment',
            sorter: true,
            scopedSlots: {
                customRender: 'commentBackoffice',
            },
        },
        {
            title: 'Programme',
            dataIndex: 'program',
            sorter: true,
            scopedSlots: {
                customRender: 'program',
            },
        },
        {
            title: 'Promoteur',
            dataIndex: 'program.promoter',
            sorter: true,
            scopedSlots: {
                customRender: 'promoter',
            },
        },
        {
          title: 'Flux Connecté',
          dataIndex: 'program.promoter.api_connected',
          sorter: false,
          scopedSlots: {
            customRender: 'boolean',
          },
        },
        {
          title: 'Date Sauv MAJ',
          dataIndex: 'program.updated_at',
          sorter: false,
          scopedSlots: {
            customRender: 'date',
          },
        },
        {
          title: 'Lots / Commentaire',
          dataIndex: 'lots',
          sorter: false,
          scopedSlots: {
            customRender: 'lots',
          },
        },
        {
            title: 'Type',
            dataIndex: 'customer.status',
            scopedSlots: {
                customRender: 'status_prospect',
            },
            sorter: true,
        },
        {
            title: 'Ville du bien',
            dataIndex: 'program.address.city',
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];

    async showPopup(denounce: Denounce,lots: Lot, prescriber: string) {
        this.lots = lots;
        this.denouncePop = denounce;
        this.prescriber = prescriber;
        this.popupLots = true;
    }

    truncateComment(text: string): string {
        if (!text) {
            return '';
        }

        const firstLine = text.split('\n')[0].trim();
        const truncated = firstLine.length > 20 ? firstLine.substring(0, 20).trim() : firstLine;

        return truncated.length < text.length ? `${truncated}…` : truncated;
    }

    openCommentPopup(record: Denounce, field: 'message_text' | 'backoffice_comment', title: string) {
        this.commentPopupRecord = record;
        this.commentPopupField = field;
        this.commentPopupTitle = title;
        this.commentPopupText = (record as any)[field] || '';
        this.commentPopupDraft = this.commentPopupText;
        this.commentPopupEditing = false;
        this.commentPopupVisible = true;
    }

    closeCommentPopup() {
        this.commentPopupEditing = false;
        this.commentPopupRecord = null;
    }

    startEditComment() {
        this.commentPopupDraft = this.commentPopupText;
        this.commentPopupEditing = true;
    }

    cancelEditComment() {
        this.commentPopupDraft = this.commentPopupText;
        this.commentPopupEditing = false;
    }

    async saveCommentPopup() {
        const $vs = (this as any).$vs;

        if (!this.commentPopupRecord || !this.commentPopupRecord.id) {
            return;
        }

        this.commentPopupSaving = true;
        try {
            const original = this.commentPopupText || '';
            const draft = this.commentPopupDraft;
            let finalText: string;

            if (!original.trim()) {
                // Premier commentaire écrit sur ce champ : on l'attribue à son auteur
                finalText = this.appendAdminComment('', draft.trim());
            } else if (draft !== original) {
                // Commentaire existant modifié : on garde le contenu édité et on trace qui l'a modifié, quand
                const userName = AuthModule.firstname || '';
                const userLastName = AuthModule.lastname || '';
                const fullName = `${userName} ${userLastName}`.trim();
                const currentDate = new Date().toLocaleDateString('fr-FR');

                finalText = draft;
                if (finalText.trim() && !finalText.endsWith('\n')) {
                    finalText += '\n';
                }
                finalText += `${fullName || 'Un utilisateur'} a modifié ce commentaire le ${currentDate}.`;
            } else {
                finalText = draft;
            }

            await patchDenounce(this.commentPopupRecord.id, {
                [this.commentPopupField]: finalText,
            } as Denounce);

            (this.commentPopupRecord as any)[this.commentPopupField] = finalText;
            this.commentPopupText = finalText;
            this.commentPopupEditing = false;

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Commentaire modifié',
                text: 'Le commentaire a bien été mis à jour',
            });

            const dt: any = (this.$refs && (this.$refs as any).datatable) ? (this.$refs as any).datatable : null;
            if (dt && typeof dt.refresh === 'function') {
                dt.refresh();
            }
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la modification du commentaire`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        } finally {
            this.commentPopupSaving = false;
        }
    }

    openCommissionPopup(record: Denounce) {
        this.commissionPopupRecord = record;
        this.commissionPopupValue = (record as any).taux_commission != null ? String((record as any).taux_commission) : '';
        this.commissionPopupDraft = this.commissionPopupValue;
        this.commissionPopupEditing = false;
        this.commissionPopupVisible = true;
    }

    closeCommissionPopup() {
        this.commissionPopupEditing = false;
        this.commissionPopupRecord = null;
    }

    startEditCommission() {
        this.commissionPopupDraft = this.commissionPopupValue;
        this.commissionPopupEditing = true;
    }

    cancelEditCommission() {
        this.commissionPopupDraft = this.commissionPopupValue;
        this.commissionPopupEditing = false;
    }

    async saveCommissionPopup() {
        const $vs = (this as any).$vs;

        if (!this.commissionPopupRecord || !this.commissionPopupRecord.id) {
            return;
        }

        if (this.commissionPopupDraft.trim() && !this.isValidTauxCommission(this.commissionPopupDraft)) {
            return;
        }

        this.commissionPopupSaving = true;
        try {
            const finalValue = this.commissionPopupDraft.trim() ? Number(this.commissionPopupDraft) : null;

            await patchDenounce(this.commissionPopupRecord.id, {
                taux_commission: finalValue,
            } as Denounce);

            (this.commissionPopupRecord as any).taux_commission = finalValue;
            this.commissionPopupValue = finalValue !== null ? String(finalValue) : '';
            this.commissionPopupEditing = false;

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Taux de commission modifié',
                text: 'Le taux de commission a bien été mis à jour',
            });

            const dt: any = (this.$refs && (this.$refs as any).datatable) ? (this.$refs as any).datatable : null;
            if (dt && typeof dt.refresh === 'function') {
                dt.refresh();
            }
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la modification du taux de commission`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        } finally {
            this.commissionPopupSaving = false;
        }
    }

    mounted() {
        const raw = getComputedStyle(document.documentElement)
            .getPropertyValue('--vs-primary')
            .trim();
        if (raw) {
            (this.$el as HTMLElement).style.setProperty('--vs-primary', raw);
        }
    }

    async created() {
        const { data } = await getNumberDenouncesPending();
        console.log('denounce pending', data);

        this.prescriberModel = undefined;
        this.programModel = undefined;
        this.statusModel = undefined;
        this.statutPrescriberModel = undefined;
        this.customersModel = undefined;

        this.operatorModel = undefined;


          // ✅ NEW: Auto-set operator filter to current user if they are an operator
        await this.setDefaultOperatorFilter();



        this.yearModel = 'all';
    }

    get fetchOperator() {
    return fetchOperatorsDenounce;
}


        get roles(): Role[] {
                return AuthModule.roles;
            }


            async setDefaultOperatorFilter() {
                try {
                    // Get the current user ID from AuthModule
                    const currentUserId = AuthModule.userID;
                    
                    if (!currentUserId || currentUserId === -1) {
                        this.operatorModel = undefined;
                        console.log('No current user logged in');
                        return;
                    }

                    // Check if current user is in the list of operators for denounces
                    const operators = await fetchOperatorsDenounce(''); // Get all operators
                    
                    // Look for current user in the operators list - FIX: Add type annotation
                    const isCurrentUserAnOperator = operators.some((operator: any) => 
                        operator.value === currentUserId
                    );

                    if (isCurrentUserAnOperator) {
                        // Set the operator filter to current user
                        this.operatorModel = currentUserId.toString();
                        
                        // Also update the meta filters immediately
                        this.meta.filters = {
                            ...this.meta.filters,
                            operator: currentUserId
                        };
                        
                        console.log('Auto-filtered to current user operator:', AuthModule.firstname, AuthModule.lastname);
                    } else {
                        this.operatorModel = undefined;
                        console.log('Current user is not an operator in denounces');
                    }
                    
                } catch (error) {
                    console.log('Error setting default operator filter:', error);
                    this.operatorModel = undefined;
                }
            }




    async fetch(meta: MetaDatatable) {
        const { data } = await getDenounces({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }
    deleteText = {
        confirm: {
            title: `Suppression de la dénonce`,
            content: `Voulez-vous vraiment supprimer la dénonce ?`,
        },
        notify: {
            title: 'Dénonce supprimé',
            content: `La dénonce a bien été supprimé`,
        },
    };
    editText = {
        notify: {
            title: 'Dénonce modifié',
            content: `La dénonce a bien été modifiée`,
        },
    };

    // Prescibers
    get fetchPrescriber() {
        return fetchPrescriberDenounce;
    }

    //Customers
    get fetchCustomer(){
        return fetchProspectsAdminDenounce;
    }

    getProjectDenounce(project: any): any {
        return this.projects[project];
    }

    getCommissionDisplay(taux_commission: any): string {
        if (taux_commission === null || taux_commission === undefined || taux_commission === '') {
            return 'NC';
        }

        const value = Number(taux_commission);
        if (isNaN(value)) {
            return 'NC';
        }

        return `${value.toLocaleString('fr-FR', { maximumFractionDigits: 2 })}%`;
    }

    // Programs
    get fetchPrograms() {
        return fetchProgramDenounce;
    }

    get yearOptions() {
        const currentYear = new Date().getFullYear();
        const years: { text: string; value: string }[] = [
            { text: 'Tous', value: 'all' }
        ];
        for (let year = currentYear; year >= 2021; year--) {
            years.push({ text: year.toString(), value: year.toString() });
        }
        return years;
    }

    @Watch('yearModel', { immediate: true })
    onYearModel() {
        this.meta.filters = {
            ...this.meta.filters,
            year: this.yearModel === 'all' ? null : this.yearModel
        };
    }

    @Watch('operatorModel', { immediate: true })
        onOperatorModel() {
            if (this.operatorModel) {
                this.meta.filters = {
                    ...this.meta.filters,
                    operator: this.operatorModel
                };
            } else if (this.meta.filters) {
                this.meta.filters = {
                    ...this.meta.filters,
                    operator: null
                };
            }
        }


        async actionDatatable(ev: {
                action: 'show' | 'edit' | 'delete' | 'add';
                item?: Denounce | null;
                }) {
                const denounce: Denounce | null = ev.item || null;

                switch (ev.action) {
                    case 'edit':
                    if (denounce && denounce.id) {
                        // Always include delete_comments; fallback to empty string for null/undefined
                        const editStatus: any = {
                        status: denounce.status,
                        delete_comments:
                            (denounce as any).delete_comments != null ? (denounce as any).delete_comments : '',
                        backoffice_comment: (denounce as any).backoffice_comment,
                        appointmentDate: (denounce as any).appointmentDate || (denounce as any).appointment_date,
                        taux_commission: (denounce as any).taux_commission,
                        };
                        await patchDenounce(denounce.id, editStatus);
                    }
                    break;

                    case 'delete':
                    if (denounce && denounce.id) {
                        this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                        };

                        denounce.status = 'canceled';
                        await deleteDenounce(denounce.id);
                    }
                    break;
                }

                await SidebarModule.fetchPendingDenounces();

                // TS 3.5-safe refresh (no optional chaining)
                const dt: any = (this.$refs && (this.$refs as any).datatable) ? (this.$refs as any).datatable : null;
                if (dt && typeof dt.refresh === 'function') {
                    dt.refresh();
                }
                }


    deleteDialog(denounce: Denounce) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(denounce),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    // MÉTHODE MODIFIÉE: editStatus avec logique spéciale pour "accepted"
    // Replace your existing editStatus method with this updated version:

// Replace your existing editStatus method with this updated version:
// Replace your existing editStatus method with this updated version:

async editStatus(denounce: Denounce) {
    const $vs = (this as any).$vs;

    if (this.messageError) {
        return;
    }

    // ✅ NOUVELLE LOGIQUE: Si le statut est "accepted", afficher le récap documents
    if (denounce.status === 'accepted' || denounce.status === 'waiting') {
        // La liste des dénonces est sérialisée avec le groupe "list", qui n'inclut pas
        // Program.documents (perf). On recharge donc le programme complet ici pour que
        // le récap affiche les vrais documents disponibles.
        if (denounce.id) {
            try {
                const { data: fullDenounce } = await getDenounce(denounce.id);
                if (fullDenounce && fullDenounce.program) {
                    denounce.program = fullDenounce.program;
                }
            } catch (e) {
                console.error('Impossible de charger les documents du programme', e);
            }
        }

        this.selectedDenounce = denounce;
        this.showDocumentsRecapPopup = true;
        this.documentsRecapStep = 1;
        this.validationBackofficeComment = '';
        this.validationTauxCommission = (denounce as any).taux_commission != null ? String((denounce as any).taux_commission) : '';

        // Generate initial comment if none exists
        if (!denounce.delete_comments || denounce.delete_comments.trim() === '') {
            this.delete_comments = this.generateInitialComment(denounce);
        } else {
            this.delete_comments = denounce.delete_comments;
        }
        
        // DON'T append status change here - it will be done in validateDenounceWithDocuments
        return;
    }

    // For other statuses, handle comment logic
    if (!this.delete_comments) {
        this.showDeleteCommentsPopUp = true;
        
        // Generate or append to existing comment
        let baseComment = '';
        
        // If there's an existing comment, preserve it
        if (denounce.delete_comments && denounce.delete_comments.trim() !== '') {
            baseComment = denounce.delete_comments;
        } else {
            // Generate initial comment structure
            baseComment = this.generateInitialComment(denounce);
        }
        
        // Add lots info if changing status (but not if it's already there)
        if (!baseComment.includes('Lots concernés') && denounce.lots) {
            let lotsStr = '\nLots concernés :\n';
            //@ts-ignore
            denounce.lots.forEach(el => lotsStr += `- Lot ${el.name}\n`);
            baseComment += lotsStr;
        }
        
        this.delete_comments = baseComment;
        this.denounce = denounce;
        return;
    } else {
        // This is when confirming from popup - now we append everything
        let finalComment = '';
        
        // If admin added a custom comment in the textarea
        if (this.delete_comments && this.delete_comments.trim() !== '') {
            const existingComment = denounce.delete_comments || '';
            
            // Check if admin added new content beyond the existing
            if (this.delete_comments !== existingComment) {
                // Find what's new in the textarea
                let newContent = this.delete_comments;
                if (this.delete_comments.startsWith(existingComment)) {
                    // New content was appended
                    newContent = this.delete_comments.substring(existingComment.length).trim();
                }
                
                if (newContent) {
                    finalComment = this.appendAdminComment(existingComment, newContent);
                } else {
                    finalComment = this.delete_comments;
                }
            } else {
                finalComment = this.delete_comments;
            }
        } else {
            finalComment = denounce.delete_comments || '';
        }
        
        // NOW append the status change (only once, here)
        if (denounce.status) {
            finalComment = this.appendStatusChange(finalComment, denounce.status);
        }
        
        denounce.delete_comments = finalComment;
    }

    try {
        await this.actionDatatable({ action: 'edit', item: denounce });

        this.delete_comments = '';
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: this.editText.notify.title,
            text: this.editText.notify.content,
        });
    } catch (error) {
        const message = get(
            error,
            'response.data.message',
            `Erreur lors de la modification de la dénonce`
        );

        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: message,
        });
    }
}





    async acceptDeleteAlert(denounce: Denounce) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: denounce });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression de la dénonce`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    get denouceStatusArr() {
        return Object.keys(denouceStatus).map(key => ({
            text: (denouceStatus as any)[key],
            value: key,
        }));
    }

    // NOUVELLES MÉTHODES POUR LE RÉCAP DOCUMENTS
    getProgramDocuments(documentType: string) {
        if (!this.selectedDenounce || !this.selectedDenounce.program || !this.selectedDenounce.program.documents) {
            return [];
        }
        
        const filtered = this.selectedDenounce.program.documents.filter(
            (doc: any) => {
                return doc.type === documentType && (doc.deletedAt === null || doc.deletedAt === undefined);
            }
        );
        
        return filtered;
    }

    getDocumentCount(documentType: string): number {
        // Cas spécial pour les images
        if (documentType === 'images') {
            return this.getImageCount();
        }
        
        // Cas normal pour les documents
        return this.getProgramDocuments(documentType).length;
    }

    getImageCount(): number {
        if (!this.selectedDenounce || !this.selectedDenounce.program || !this.selectedDenounce.program.images) {
            return 0;
        }
        
        return Array.isArray(this.selectedDenounce.program.images) 
            ? this.selectedDenounce.program.images.length 
            : (this.selectedDenounce.program.images ? 1 : 0);
    }

    // 'ok' | 'missing' | 'essential-missing'
    getDocumentLevel(documentType: string): string {
        const count = this.getDocumentCount(documentType);
        const docTypeInfo = this.documentTypesList.find(d => d.key === documentType);

        if (count === 0 && docTypeInfo && docTypeInfo.essential) {
            return 'essential-missing';
        } else if (count === 0) {
            return 'missing';
        } else {
            return 'ok';
        }
    }

    getDocumentStatusClass(documentType: string): string {
        return `doc-card--${this.getDocumentLevel(documentType)}`;
    }

    getDocumentIndicatorClass(documentType: string): string {
        return `doc-card-icon--${this.getDocumentLevel(documentType)}`;
    }

    getDocumentIcon(documentType: string): string {
        const level = this.getDocumentLevel(documentType);
        if (level === 'ok') return 'fa-check';
        if (level === 'essential-missing') return 'fa-exclamation';
        return 'fa-minus';
    }

    getDocumentCountClass(documentType: string): string {
        return `doc-card-count--${this.getDocumentLevel(documentType)}`;
    }

    isDocumentEssential(documentType: string): boolean {
        const docTypeInfo = this.documentTypesList.find(d => d.key === documentType);
        return !!(docTypeInfo && docTypeInfo.essential);
    }

    getTotalDocumentsPresent(): number {
        return this.documentTypesList.reduce((total, docType) => {
            return total + this.getDocumentCount(docType.key);
        }, 0);
    }

    getEssentialTotalCount(): number {
        return this.documentTypesList.filter(d => d.essential).length;
    }

    getEssentialPresentCount(): number {
        return this.documentTypesList
            .filter(d => d.essential)
            .reduce((count, docType) => {
                return count + (this.getDocumentCount(docType.key) > 0 ? 1 : 0);
            }, 0);
    }

    getEssentialCompletionPercent(): number {
        const total = this.getEssentialTotalCount();
        if (total === 0) return 100;
        return Math.round((this.getEssentialPresentCount() / total) * 100);
    }

    getTotalDocumentsClass(): string {
        const essential = this.getEssentialTotalCount();
        const essentialPresent = this.getEssentialPresentCount();

        if (essentialPresent === essential) {
            return 'recap-progress-bar--good';
        } else if (essentialPresent > essential / 2) {
            return 'recap-progress-bar--warning';
        } else {
            return 'recap-progress-bar--bad';
        }
    }

    getMissingDocuments(): string[] {
        return this.documentTypesList
            .filter(docType => {
                return this.getDocumentCount(docType.key) === 0;
            })
            .map(docType => docType.key);
    }

    getDocumentLabel(documentType: string): string {
        const docType = this.documentTypesList.find(d => d.key === documentType);
        return docType ? docType.label : documentType;
    }

    formatDate(dateString: string): string {
        return dateString ? moment(dateString).format('DD/MM/YYYY') : '';
    }

    getDocumentUrl(document: any): string {
        // Construire l'URL complète du document
        const baseUrl = window.location.origin;
        return `${baseUrl}${document.url}${document.name}.${document.extension}`;
    }

// Replace the existing generateDefaultComment method with these two methods:

// Method to generate initial comment for new denounces
generateInitialComment(denounce: Denounce): string {
    const programName = (denounce.program && denounce.program.name) || 'le programme';
    const programCity = (denounce.program && denounce.program.address && denounce.program.address.city) || '';
    const promoterName = (denounce.program && denounce.program.promoter && denounce.program.promoter.name) || '';
    
    let comment = `Dénonce pour le programme "${programName}"`;
    
    if (programCity) {
        comment += ` à ${programCity}`;
    }
    
    if (promoterName) {
        comment += ` (Promoteur: ${promoterName})`;
    }
    
    comment += '.\n\n';
    
    // Add lots information
    if (denounce.lots && Array.isArray(denounce.lots) && denounce.lots.length > 0) {
        comment += `Lots concernés :\n`;
        denounce.lots.forEach((lot: any) => {
            comment += `- Lot ${lot.name}`;
            if (lot.type) {
                comment += ` (${lot.type})`;
            }
            if (lot.type2) {
                comment += ` - ${lot.type2}`;
            }
            comment += '\n';
        });
        comment += '\n';
    }
    
    return comment;
}

// Method to append status change to existing comment
appendStatusChange(existingComment: string, newStatus: string, previousStatus?: string): string {
    const userName = AuthModule.firstname || '';
    const userLastName = AuthModule.lastname || '';
    const fullName = `${userName} ${userLastName}`.trim();
    const currentDate = new Date().toLocaleDateString('fr-FR');
    
    let statusText = '';
    let authorInfo = fullName ? ` (${fullName})` : '';
    
    switch (newStatus) {
        case 'accepted':
            statusText = 'Validation effectuée';
            break;
        case 'waiting':
            statusText = 'Mise en attente';
            break;
        case 'pending':
            statusText = 'Mise en attente';
            break;
        case 'refused':
            statusText = 'Refus effectué';
            break;
        case 'canceled':
            statusText = 'Annulation effectuée';
            break;
        default:
            statusText = `Changement de statut vers "${newStatus}"`;
            break;
    }
    
    // Clean existing comment and prepare for append
    let cleanedComment = existingComment || '';
    
    // If there's no existing comment, generate the initial one first
    if (!cleanedComment.trim()) {
        // This should ideally get the denounce object, but for now we'll add a basic header
        cleanedComment = "Historique de la dénonce :\n\n";
    }
    
    // Add separator if there's already content
    if (cleanedComment.trim() && !cleanedComment.endsWith('\n')) {
        cleanedComment += '\n';
    }
    
    // Add the new status change
    cleanedComment += `${statusText} le ${currentDate}${authorInfo}.\n`;
    
    return cleanedComment;
}

// Method to append custom admin comment
appendAdminComment(existingComment: string, adminComment: string): string {
    const userName = AuthModule.firstname || '';
    const userLastName = AuthModule.lastname || '';
    const fullName = `${userName} ${userLastName}`.trim();
    const currentDate = new Date().toLocaleDateString('fr-FR');
    
    let cleanedComment = existingComment || '';
    
    // Add separator if there's already content
    if (cleanedComment.trim() && !cleanedComment.endsWith('\n')) {
        cleanedComment += '\n';
    }
    
    // Add the admin comment with attribution
    if (fullName) {
        cleanedComment += `Commentaire de ${fullName} le ${currentDate} :\n${adminComment}\n\n`;
    } else {
        cleanedComment += `Commentaire administrateur le ${currentDate} :\n${adminComment}\n\n`;
    }
    
    return cleanedComment;
}

    // Méthodes utilitaires pour le commentaire par défaut (simplifiées)
    getDocumentCountForDenounce(denounce: Denounce, documentType: string): number {
        if (!denounce.program) return 0;

        if (documentType === 'images') {
            if (!denounce.program.images) return 0;
            return Array.isArray(denounce.program.images) 
                ? denounce.program.images.length 
                : (denounce.program.images ? 1 : 0);
        }

        if (!denounce.program.documents) return 0;
        return denounce.program.documents.filter(
            (doc: any) => doc.type === documentType && (doc.deletedAt === null || doc.deletedAt === undefined)
        ).length;
    }

    getTotalDocumentsPresentForDenounce(denounce: Denounce): number {
        return this.documentTypesList.reduce((total, docType) => {
            return total + this.getDocumentCountForDenounce(denounce, docType.key);
        }, 0);
    }

    // Méthodes pour gérer la popup documents
    cancelDocumentsRecap(): void {
        this.showDocumentsRecapPopup = false;
        this.selectedDenounce = null;
        this.delete_comments = '';
        this.validationBackofficeComment = '';
        this.validationTauxCommission = '';
        this.documentsRecapStep = 1;
    }

    goToBackofficeStep(): void {
        if (this.messageError || !this.delete_comments.trim()) {
            return;
        }
        this.validationBackofficeComment = '';
        this.documentsRecapStep = 2;
    }

    isValidTauxCommission(value: string | number): boolean {
        if (value === '' || value === null || value === undefined) {
            return true;
        }
        const num = Number(value);
        return !isNaN(num) && num >= 0.01 && num <= 99.99;
    }

    // Replace your existing validateDenounceWithDocuments method:

// Replace your existing validateDenounceWithDocuments method:

// Replace your existing validateDenounceWithDocuments method:

async validateDenounceWithDocuments() {
    if (
        !this.selectedDenounce ||
        !this.selectedDenounce.status ||
        !this.delete_comments.trim() ||
        !this.validationBackofficeComment.trim() ||
        (this.validationTauxCommission.trim() && !this.isValidTauxCommission(this.validationTauxCommission))
    ) {
        return;
    }

    this.showDocumentsRecapPopup = false;

    try {
        let finalComment = '';

        // If user modified the textarea (added custom content)
        const originalComment = this.selectedDenounce.delete_comments || '';
        if (this.delete_comments !== originalComment) {
            // Check if user added new content
            let newContent = this.delete_comments;
            if (this.delete_comments.startsWith(originalComment)) {
                newContent = this.delete_comments.substring(originalComment.length).trim();
            }

            if (newContent) {
                finalComment = this.appendAdminComment(originalComment, newContent);
            } else {
                finalComment = this.delete_comments;
            }
        } else {
            finalComment = this.delete_comments;
        }

        // NOW append the status change (this is where it should happen for accepted/waiting)
        if (this.selectedDenounce.status) {
            finalComment = this.appendStatusChange(finalComment, this.selectedDenounce.status);
        }

        this.selectedDenounce.delete_comments = finalComment;

        // Commentaire BackOffice obligatoire : ajouté avec attribution (auteur + date), comme pour delete_comments
        const originalBackofficeComment = this.selectedDenounce.backoffice_comment || '';
        this.selectedDenounce.backoffice_comment = this.appendAdminComment(
            originalBackofficeComment,
            this.validationBackofficeComment.trim()
        );

        (this.selectedDenounce as any).taux_commission = this.validationTauxCommission.trim()
            ? Number(this.validationTauxCommission)
            : null;

        await this.actionDatatable({ action: 'edit', item: this.selectedDenounce });

        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: this.editText.notify.title,
            text: this.editText.notify.content,
        });
        
        // Rafraîchir le datatable
        const $datatable = this.$refs.datatable as any;
        if ($datatable && $datatable.refresh) {
            $datatable.refresh();
        }
        
    } catch (error) {
        const message = get(
            error,
            'response.data.message',
            `Erreur lors de la modification de la dénonce`
        );

        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: message,
        });
    }

    // Nettoyage
    this.selectedDenounce = null;
    this.delete_comments = '';
    this.validationBackofficeComment = '';
    this.documentsRecapStep = 1;
}



    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    prescriberModel: string | undefined | null = null;
    programModel: string | undefined | null = null;
    statusModel: string | undefined | null = null;
    statutPrescriberModel: string | undefined | null = null;
    customersModel: string | undefined | null = null;

    get statusPrescripteurValues(){
        return [
            { text: 'CGPi', value: 'CGPi' },
            { text: 'CGP Mandataire', value: 'CGP Mandataire' },
            {
                text: 'Conseiller Immobilier Neuf carte T',
                value: 'Conseiller Immobilier Neuf carte T',
            },
            {
                text: 'Conseiller Immobilier Neuf Mandataire',
                value: 'Conseiller Immobilier Neuf Mandataire',
            },
            { text: 'CIF', value: 'CIF' },
            {
                text: 'Agent Immobilier Ancien Carte T',
                value: 'Agent Immobilier Ancien Carte T',
            },
            {
                text: 'Mandataire Immobilier Ancien',
                value: 'Mandataire Immobilier Ancien',
            },
        ]
    }

    @Watch('meta', { deep: true, immediate: true })
    onMeta() {
        if (this.meta.filters && this.meta.filters.prescriber) {
            this.prescriberModel = this.meta.filters.prescriber;
        } else {
            this.prescriberModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.program) {
            this.programModel = this.meta.filters.program;
        } else {
            this.programModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.status) {
            this.statusModel = this.meta.filters.status;
        } else {
            this.statusModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.statusPrescriber) {
            this.statutPrescriberModel = this.meta.filters.statusPrescriber;
        } else {
            this.statutPrescriberModel = undefined;
        }

        if (this.meta.filters && this.meta.filters.customer) {
            this.customersModel = this.meta.filters.customer;
        } else {
            this.customersModel = undefined;
        }
        if (this.meta.filters && this.meta.filters.year) {
        this.yearModel = this.meta.filters.year;
        } else {
            this.yearModel = 'all';
        }

        if (this.meta.filters && this.meta.filters.operator) {
                this.operatorModel = this.meta.filters.operator;
            } else {
                this.operatorModel = undefined;
            }


    }

    @Watch('prescriberModel', { immediate: true })
    onPrescriberModel() {
        if (this.prescriberModel) {
            this.meta.filters ={
                prescriber: this.prescriberModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                prescriber: null
            };
        }
    }

    onStatutPrescriberModel(){

        if (this.statutPrescriberModel) {
            this.meta.filters = {
                statusPrescriber: this.statutPrescriberModel
            };
        } else if (this.meta.filters) {
            this.meta.filters ={
                statusPrescriber: null
            };
        }
    }
    @Watch('customersModel', { immediate: true })
    onCustomersModel(){
        if (this.customersModel) {
            this.meta.filters = {
                customer: this.customersModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                customer: null
            };
        }
    }

    @Watch('programModel', { immediate: true })
    onProgramModel() {
        if (this.programModel) {
            this.meta.filters = {
                program: this.programModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                program: null
            };
        }
    }

    @Watch('statusModel', { immediate: true })
    onStatusModel() {
        if (this.statusModel) {
            this.meta.filters = {
                status: this.statusModel
            };
        } else if (this.meta.filters) {
            this.meta.filters = {
                status: null
            };
        }
    }


    getStatusChipClass(status: string | undefined): string {
        switch (status) {
            case 'accepted':
                return 'success';
            case 'refused':
                return 'danger';
            case 'pending':
                return 'warning';
            case 'canceled':
                return 'danger';
            default:
                return 'primary';
        }
    }




    get messageError() {
        if (this.delete_comments.length > 500000) {
            console.log(this.delete_comments.length)
            return '500000 caractères maximum';
        }

        return null;
    }
}
